import { forwardRef } from "react";

import { Select } from "@shared/components/DataEntry";

import { FormField } from "../FormField";
import { FormSelectProps } from "../../types";

export const FormSelect = forwardRef<HTMLSelectElement, FormSelectProps>(({ name, ...props }, ref) => (
  <FormField name={name}>
    <Select ref={ref} name={name} {...props} />
  </FormField>
));

FormSelect.displayName = "Form.Select";
